import React from "react";

export default function stopPropagation(e: React.MouseEvent) {
  e.stopPropagation();
}
